import { Button, Div, Flex, Text } from '@sendoutcards/quantum-design-ui'
import React from 'react'
import { Transition } from 'src/chrome'
import { CertifiedCoachBadge } from 'src/coaching/svg/certifiedCoachBadge'
import { CoachingBadgeType } from 'src/coaching/svg/coachingBadgeSVGs'
import { Portal } from 'src/portal/portal'
import { Clipboard } from './components/Clipboard'
import { useQueryFutures } from 'src/hooks'
import { getByDesignLoginLink } from 'src/legacy_graphql'

interface Props {
  title: string
  date: string
  location: string
  badge: CoachingBadgeType
  code?: {
    title: string
    value: string
  }
  action?: {
    onClick?: () => void
    onBydesignRedirect?: string
    title: string
  }
}

const CoachingEventCard: React.FC<Props> = props => {
  const { title, date, location, code, action, badge } = props

  const [
    { isUnresolved: isCreatingBydesignLoginLink, value: byDesignLoginLink },
  ] = useQueryFutures(getByDesignLoginLink())

  const onActionClick = () => {
    if (action?.onClick) {
      action.onClick()
    }
    if (action?.onBydesignRedirect) {
      window.open(`${byDesignLoginLink}/${action?.onBydesignRedirect}`)
    }
  }

  return (
    <>
      {isCreatingBydesignLoginLink && (
        <Portal>
          <Div position="absolute" zIndex={1000}>
            <Transition />
          </Div>
        </Portal>
      )}
      <Flex
        backgroundColor="foreground"
        borderRadius="default"
        flexDirection="column"
        alignItems="center"
        inset={{ top: 'x1', horizontal: 'x3', bottom: 'x2' }}
        alignContent="center"
        justifyContent="space-between"
        rowGap="x1_5"
        minWidth="225px"
        maxHeight="500px"
        style={{
          boxShadow: '0px 0px 8px rgba(0, 0, 0, 0.08)',
        }}
      >
        <Div maxWidth="9rem">
          <Text
            type="body"
            color="anchorBlue"
            content={title}
            whiteSpace="normal"
            alignment="center"
            weight="extraBold"
            style={{ fontWeight: 700 }}
          />
          <Flex flexDirection="column" alignItems="center">
            <Text
              type="footnote"
              color="primaryBody"
              content="Next Event"
              weight="bold"
              style={{ fontWeight: 700 }}
            />
            <Text
              type="footnote"
              color="primaryBody"
              content={date}
              weight="bold"
              style={{ color: '#bebebe', fontWeight: 700 }}
            />
            <Text
              type="footnote"
              color="primaryBody"
              content={location}
              weight="bold"
              style={{ color: '#bebebe', fontWeight: 700 }}
            />
          </Flex>
        </Div>
        <CertifiedCoachBadge badge={badge} size={150} />
        <Div
          display="flex"
          flexDirection="column"
          rowGap="x1"
          minHeight="120px"
          justifyContent="space-evenly"
        >
          {code && (
            <Flex flexDirection="column" alignItems="center">
              <Text
                type="footnote"
                content={code?.title}
                weight="bold"
                style={{ color: '#bebebe', fontWeight: 700 }}
              />
              <Clipboard copyText={code?.value} />
            </Flex>
          )}
          {action && (
            <Flex width="100%" inset={{ horizontal: 'x3' }}>
              <Button
                type="secondary"
                title={action.title}
                onClick={onActionClick}
                fullWidth={true}
                size="small"
              />
            </Flex>
          )}
        </Div>
      </Flex>
    </>
  )
}

export default CoachingEventCard
